import { render, staticRenderFns } from "./Downloadable.vue?vue&type=template&id=62210683&scoped=true"
import script from "./Downloadable.ts?vue&type=script&lang=ts&external"
export * from "./Downloadable.ts?vue&type=script&lang=ts&external"
import style0 from "./Downloadable.vue?vue&type=style&index=0&id=62210683&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62210683",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62210683')) {
      api.createRecord('62210683', component.options)
    } else {
      api.reload('62210683', component.options)
    }
    module.hot.accept("./Downloadable.vue?vue&type=template&id=62210683&scoped=true", function () {
      api.rerender('62210683', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/pages/Downloadable/Downloadable.vue"
export default component.exports